module.exports = __webpack_public_path__ + "img/clogo.ee103f53.png";